export const _recurringSaleClass = {
  name: { type: 'string', title: 'Myyntikampanjan nimi (esim Tennis 24/25)' },
  seasonstart: {
    type: 'string',
    format: 'date',
    title: 'Kauden ensimmäinen päivä',
  },
  seasonend: {
    type: 'string',
    format: 'date',
    title: 'Kauden viimeinen päivä',
  },
  campaignstart: {
    type: 'string',
    format: 'date',
    title: 'Myyntikampanjan aloituspäivä',
  },
  campaignend: {
    type: 'string',
    format: 'date',
    title: 'Myyntikampanjan päättymispäivä',
  },
  description: { type: 'string', title: 'Kuvaus' },
  payment: {
    type: 'string',
    title: 'Maksu',
    oneOf: [
      { const: 'postpaidcreditcard', title: 'Jälkikäteen tallennettu kortti (veloitus 30 min vuoron jälkeen)' },
      { const: 'prepaidfull', title: 'Etukäteen kokokausi' },
      { const: 'prepaidpartly', title: 'Etukäteen osakausi (tulossa)' },
      { const: 'postpaidinvoice', title: 'Jälkikäteen lasku' },
      { const: 'inquiry', title: 'Tiedustelu' },
    ],
  },
  // Where a Tiedustelu campaign sends its enquiries. Plain string rather than
  // format: 'email' - the field is optional, and ajv rejects '' against the email
  // format, which would block saving every campaign that does not use it. The label
  // map in RecurringSalesContainer has to list the same payment options.
  inquiryemail: {
    type: 'string',
    title: 'Tiedustelujen sähköposti',
    description: 'Käytetään kun maksutapa on Tiedustelu — tähän osoitteeseen lähetetään asiakkaan tiedustelu.',
  },
  confirmation: {
    type: 'boolean',
    title: 'Vahvistetaanko vuoron myynti?',
  },
  contract: {
    type: 'string',
    title: 'Sopimus',
    oneOf: [
      { const: 'creditcard', title: 'Talletettu luottokortti (tulossa)' },
      { const: 'esignature', title: 'Sähköinen allekirjoitus' },
      { const: 'prepaid', title: 'Maksu etukäteen' },
      { const: 'none', title: 'Ei mitään' },
    ],

  },
  // resources: {
  //   type: "array",
  //   title: "Resurssit",
  //   items: {
  //     type: "string",
  //     "enum": [],
  //     'enumNames': []
  //   },
  //   "uniqueItems": true
  // },
  pricing: {
    title: 'Hinnoittelu',
    type: 'string',
    oneOf: [],
  },
  confirmationMessage: { type: 'string', title: 'Vahvistusviestin sisältö' },
  state: {
    type: 'string',
    title: 'Tila',
    oneOf: [
      { const: 'draft', title: 'Luonnos' },
      { const: 'active', title: 'Käynnissä' },
      { const: 'paused', title: 'Keskeytetty' },
    ],
  },
}

export const _textBannerClassDeps = {
  format: {
    oneOf: [
      {
        properties: {
          format: {
            enum: ['info'],
          },
        },
      },
      {
        properties: {
          format: {
            enum: ['textad'],
          },
          linktitle: {
            type: 'string',
            title: 'Otsikko',
          },
          link: {
            type: 'string',
            title: 'Linkki',
          },
          externalctt: {
            type: 'string',
            title: 'Ulkoinen clickthrough linkki',
          },
        },
      },
    ],
  }
}

export const _recurringSaleUISchema = {
  // postpaidcreditcard is live since falcon 885ea04 (charged after play by paymentv3-billrecurring).
  // prepaidpartly is not implemented end to end yet. Kept in the schema so existing campaigns
  // that already carry the value still render a label, but greyed out in the picker so nobody
  // selects it - its title above says (tulossa). Drop it from the list here once the backend
  // supports it.
  payment: {
    'ui:enumDisabled': ['prepaidpartly'],
  },
  contract: {
    'ui:enumDisabled': ['creditcard'],
  },
  content: {
    'ui:widget': 'textarea',
  },
  confirmationMessage: {
    'ui:widget': 'editorWidget',
  },
  description: {
    'ui:widget': 'editorWidget',
  },
}
